module.exports = __webpack_public_path__ + "static/img/album-status-3.0cfa4836.png";